// @ts-nocheck





import {
  downloadRequestWithToken,
  fetchRequest,
  initialFetchListParams } from
'./index';



const fetchJournals = async (
params = initialFetchListParams) =>

await fetchRequest.get('/journal', {
  ...initialFetchListParams,
  ...params
});

export const fetchJournal = async (
id,
params = {}) =>
{
  const journal = await fetchRequest.get(`/journal/${id}`, params);
  if (journal) return journal;
  throw new Error('Не удалось загрузить сотрудника');
};

export const printJournal = async () => {
  const print = await downloadRequestWithToken(`/journal/print`);
  if (print) return print;
  throw new Error('Не удалось загрузить журнал');
};

export default {
  fetchJournals,
  fetchJournal,
  printJournal
};